const ValidateForm = (formId) => {
    let check = true;
    const errorState = (item, message) => {
        item.style.border = '1.5px solid #ae1536';
        item.style.boxShadow = "0 0 0 2px rgba(240, 82, 82, 0.1)";
        item.nextSibling.style.display = 'block';
        item.nextSibling.innerHTML = message;
        check = false;
    };
    const normalState = (item) => {
        item.style.border = '1px solid #E8E6E7';
        item.style.boxShadow = "0 1px 2px 0 rgba(85, 104, 125, 0.1)";
        item.nextSibling.style.display = 'none';
    };
    Array.from(document.getElementById(formId).querySelectorAll('input, select, textarea')).forEach(item => {
        if (item.hasAttribute('required')) {
            if (item.value) normalState(item);
            else errorState(item, 'This field is required!');
        }
        if (item.value) {
            if (item.hasAttribute('min')) {
                if (Number(item.value) < Number(item.getAttribute('min'))) errorState(item, `Value must be greater than ${item.getAttribute('min')}`);
                else normalState(item);
            }
            if (item.hasAttribute('max')) {
                if (Number(item.value) > Number(item.getAttribute('max'))) errorState(item, `Value must be lesser than ${item.getAttribute('max')}`);
                else normalState(item);
            }
            if (item.getAttribute('type') === 'email') {
                const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (regex.test(item.value)) normalState(item);
                else errorState(item, 'Please enter a valid email');
            }
        }
    })
    return check;
}

export default ValidateForm;